import React from 'react';
import { withStyles, makeStyles, Theme, createStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';

import Card from '@material-ui/core/Card';
import Paper from '@material-ui/core/Paper';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Slider from '@material-ui/core/Slider';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      maxWidth: 460,
      marginLeft: 15
    },
    left: {
      background: '#444',
      "& h4": {
        color: '#eee'
      },
      "& hr": {
        margin: '5px auto',
        background: '#fff'
      },
      "& div": {
        color: '#aaa',
      },
      "& p": {
        color: '#ccc',
        fontSize: 13,
        marginBottom: 15
      },
      "& span": {
        margin: '15px 3px 5px 0',
        background: 'lightbule',
        fontSize: 10,
        padding: '1px 3px',
      }
    },
    lefttext: {
      fontSize: 12
    },
    right: {
      background: '#ddd'
    },
    media: {
      height: 100,
      width: 90,
      margin: '20px auto 0'

    },

    smallroot: {
      maxWidth: 260,
      height: 240,
      marginRight: 15
    },
    smallleft: {
      background: '#444',
      "& h4": {
        color: '#eee'
      },
      "& hr": {
        margin: '5px auto',
        background: '#fff'
      },
      "& div": {
        color: '#aaa',
      },
      "& p": {
        color: '#ccc',
        fontSize: 13,
        marginBottom: 15
      },
      "& span": {
        margin: '0 auto 2px auto',
        background: 'lightbule',
        fontSize: 10,
        padding: '0 3px',
        display: 'block',
        textAlign: 'center'
      }
    },
    smalllefttext: {
      fontSize: 9
    },
    smalltitle: {
      fontSize: 12
    },
    smallright: {
      background: '#ddd',
      "& p": {
        fontSize: 12,
        marginBottom: 15
      },
    },
    smallmedia: {
      height: 70,
      width: 60,
      margin: '20px auto 0'

    },
    firstCul: {
      paddingTop: 9,
      fontSize: '0.9em'
    },
    firstCulHeight: {
      height: 25
    },
    videomedia: {
      height: 100,
      width: '100%',
      margin: '20px auto 20px',
      border: '15px solid #bbb',
      padding: 2
    },
    logo: {
      height: 30,
      width: 30,
      margin: '4px',
    },
  }),
);

const PrettoSlider = withStyles({
  root: {
    color: 'green',
    height: 8,
  },
  thumb: {
    height: 14,
    width: 14,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    marginTop: -3,
    marginLeft: -6,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 8,
    borderRadius: 0,
  },
  rail: {
    height: 8,
    borderRadius: 0,
  },
  mark: {
    height: 8,
    borderRadius: 0,
  }
})(Slider);

export default function UserCard(props) {
  const { user } = props;
  const classes = useStyles();

  return (
    <>
      <Card className={classes.smallroot} >
        <Grid container spacing={2}>
          <Grid item xs={6} className={classes.smallleft}>
            <CardMedia
              className={classes.smallmedia}
              image="/img/kep.png"
              title=""
            />
            <CardContent>
              <Typography component="h4" align="center" className={classes.smalltitle} >
                {[user.user.lastname, user.user.middleName, user.user.firstname].join(' ')}
              </Typography>
              <Typography align="center" className={classes.smalllefttext} component="div">
                {user.user.city}
              </Typography>
              <Typography align="center" className={classes.smalllefttext} component="div">
                {"+36-" + user.user.phoneNumber}
              </Typography>
              <Divider component="hr" />

              {
                ["pontos", "megbizható", "rugalmas"].map((item, index) => <Paper key={`p1-${index}`} component="span">{item}</Paper>)
              }
            </CardContent>
          </Grid>
          <Grid item xs={6} className={classes.smallright}>
            <CardContent>
              <Typography variant="body2" color="textSecondary" component="p">
                Suspendisse potenti. Nunc laoreet ut ex a consequat. Phasellus lacinia nec ipsum vel accumsan. Proin iaculis dolor elit, sed sagittis est lacinia vitae.
            </Typography>

            </CardContent>
          </Grid>
        </Grid>
      </Card>

      <Card className={classes.root}>
        <Grid container spacing={2}>
          <Grid item xs={5} className={classes.left}>
            <CardMedia
              className={classes.media}
              image="/img/kep.png"
              title=""
            />

            <CardContent>
              <Typography component="h4" align="center">
                {[user.user.lastname, user.user.middleName, user.user.firstname].join(' ')}
              </Typography>
              <Typography align="center" className={classes.lefttext} component="div">
                {user.user.birthDate}
              </Typography>
              <Typography align="center" className={classes.lefttext} component="div">
                {[user.user.country, user.user.city].join(', ')}
              </Typography>
              <Typography align="center" className={classes.lefttext} component="div">
                {"+36-" + user.user.phoneNumber}
              </Typography>
              <Divider component="hr" />
              <Typography variant="body2" color="textSecondary" component="p">

              </Typography>
              <CardMedia
                className={classes.videomedia}
                image="/img/video.png"
                title=""
              />
              {console.log("rerend ", user.settings.property)}
              {
                Object.entries(user.settings.property).map((item, index) => item[1].status && <Paper key={`p2-${index}`} component="span">{item[1].text}</Paper>)
              }
            </CardContent>
          </Grid>
          <Grid item xs={7} className={classes.right}>
            <CardContent>
              <Grid container>
                {user.settings.property.map((item, index) => item.checked &&
                  <Grid key={`g1-${index}`} container className={classes.firstCulHeight}>
                    <Grid item xs={6} className={classes.firstCul}>
                      {item.title}
                    </Grid>
                    <Grid item xs={6} >
                      {console.log("value", item.value)}
                      <PrettoSlider
                        valueLabelDisplay="auto"
                        aria-label="pretto slider"
                        defaultValue={item.value}
                        value={item.value}
                        min={0}
                        max={10}
                        step={1}
                        marks
                      />
                    </Grid>
                  </Grid>
                )
                }
              </Grid>
              <br />
              <Typography component="h3" style={{ marginBottom: 6 }}>Lorem Ipsum</Typography>
              <Typography variant="body2" color="textSecondary" component="p">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tristique,  sed cursus ante enim ac purus. Proin vitae nunc lectus. Nunc non rhoncus libero. Praesent eu felis et nulla eleifend auctor vel sed elit. Aenean tincidunt lorem eleifend mi pellentesque, eu sollicitudin dui commodo.
            </Typography>
              <Grid container>
                <CardMedia className={classes.logo} image="/img/logo1.png" title="" />
                <CardMedia className={classes.logo} image="/img/logo2.png" title="" />
                <CardMedia className={classes.logo} image="/img/logo3.png" title="" />
                <CardMedia className={classes.logo} image="/img/logo4.png" title="" />
                <CardMedia className={classes.logo} image="/img/logo5.png" title="" />
                <CardMedia className={classes.logo} image="/img/logo6.png" title="" />
              </Grid>
            </CardContent>
          </Grid>
        </Grid>
      </Card>
    </>
  );
}